import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function Logout() {
  const history = useNavigate();
  useEffect(() => {
    localStorage.removeItem("jwt");
    history("/");
  });
  return <h1>Logout</h1>;
}
